var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "templateBox"
  }, [_c('div', {
    staticClass: "pc-main"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.backtopShow,
      expression: "backtopShow"
    }]
  }, [_c('el-backtop', {
    attrs: {
      "visibility-height": 0,
      "right": 0,
      "bottom": 0
    }
  }, [_c('img', {
    staticClass: "up",
    attrs: {
      "src": require("../../../assets/pcimg/up.png"),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "up-active",
    attrs: {
      "src": require("../../../assets/pcimg/up-active.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "backtop-text"
  }, [_vm._v("顶部")])])], 1), _c('div', {
    class: _vm.isTop ? 'header header-bg' : 'header'
  }, [_c('div', {
    staticClass: "header-box"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": require("../../../assets/pcimg/loginww.png"),
      "alt": ""
    },
    on: {
      "click": _vm.getlogo
    }
  }), _vm._l(_vm.list, function (item, index) {
    return _c('ul', {
      key: index,
      staticClass: "header-ul"
    }, [_c('li', {
      class: _vm.id == item.navId ? 'header-li' : 'header-lis',
      on: {
        "click": function ($event) {
          return _vm.navtab(item.navId, index, item.url);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " "), _c('p', {
      staticClass: "hang"
    })])]);
  }), _c('div', {
    class: _vm.id == 1 ? 'header-li' : 'header-lis',
    on: {
      "click": _vm.gowlw
    }
  }, [_vm._v(" 定制开发 "), _c('ul', {
    staticClass: "children-list"
  }, [_c('li', {
    staticClass: "children-list-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.wlwClick(0);
      }
    }
  }, [_vm._v(" 物联网开发 ")])])]), _c('div', {
    class: _vm.id == 5 ? 'header-li' : 'header-lis',
    on: {
      "click": _vm.goIDC
    }
  }, [_vm._v(" IDC服务 "), _c('ul', {
    staticClass: "children-list"
  }, [_c('li', {
    staticClass: "children-list-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.IDCClick(0);
      }
    }
  }, [_vm._v(" 服务器租赁 ")]), _c('li', {
    staticClass: "children-list-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.IDCClick(2);
      }
    }
  }, [_vm._v(" 域名注册及备案 ")]), _c('li', {
    staticClass: "children-list-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.IDCClick(1);
      }
    }
  }, [_vm._v(" SSL证书 ")])])]), _vm._l(_vm.lists, function (item, index) {
    return _c('ul', {
      key: item.name,
      staticClass: "header-ul"
    }, [_c('li', {
      class: _vm.id == item.navId ? 'header-li' : 'header-lis',
      on: {
        "click": function ($event) {
          return _vm.navtab(item.navId, index, item.url);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " "), _c('p', {
      staticClass: "hang"
    })])]);
  }), _c('div', {
    staticClass: "personal-center",
    on: {
      "mouseenter": _vm.concealpersonal,
      "mouseleave": _vm.showpersonalFn
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.headshow,
      expression: "headshow"
    }],
    staticClass: "header-img2",
    attrs: {
      "rel": "nofollow",
      "src": require("../../../assets/pcimg/Slice 4032x.png"),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.headsshow,
      expression: "headsshow"
    }],
    staticClass: "header-img2",
    attrs: {
      "rel": "nofollow",
      "src": _vm.head,
      "alt": ""
    },
    on: {
      "click": _vm.getpersonal
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLogin,
      expression: "showLogin"
    }],
    staticClass: "dl",
    on: {
      "click": _vm.login
    }
  }, [_vm._v(" " + _vm._s(_vm.logins) + " ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLogin,
      expression: "showLogin"
    }],
    staticClass: "blank"
  }, [_vm._v("/")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showRegister,
      expression: "showRegister"
    }],
    staticClass: "zc",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(" " + _vm._s(_vm.registers) + " ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showpersonal,
      expression: "showpersonal"
    }],
    staticClass: "zx",
    on: {
      "click": _vm.getpersonal
    }
  }, [_vm._v(" " + _vm._s(_vm.personal) + " ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.personalcenter1 & _vm.showpersonal,
      expression: "personalcenter1 & showpersonal"
    }],
    class: _vm.personalId == 0 ? '' : 'personal-center1'
  }, [_c('p', {
    staticClass: "children-list-item",
    on: {
      "click": _vm.getoffer
    }
  }, [_vm._v(_vm._s(_vm.offer))]), _c('p', {
    staticClass: "children-list-item",
    on: {
      "click": _vm.gettechnology
    }
  }, [_vm._v(" " + _vm._s(_vm.technology) + " ")]), _c('p', {
    staticClass: "children-list-item",
    on: {
      "click": _vm.getrecord
    }
  }, [_vm._v(" " + _vm._s(_vm.record) + " ")]), _c('p', {
    staticClass: "children-list-item",
    on: {
      "click": _vm.getresume
    }
  }, [_vm._v(" " + _vm._s(_vm.resume) + " ")]), _c('p', {
    staticClass: "children-list-item",
    on: {
      "click": _vm.eliminate
    }
  }, [_vm._v(_vm._s(_vm.quit))])])])], 2)])])]), _c('div', {
    staticClass: "mobile-main"
  }, [_c('div', {
    staticClass: "boxbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mobileNavShow,
      expression: "mobileNavShow"
    }],
    staticClass: "tab"
  }, [_vm.tabShow == true ? _c('img', {
    staticClass: "tab-logo",
    attrs: {
      "src": _vm.getlogos,
      "alt": ""
    },
    on: {
      "click": _vm.getlogo
    }
  }) : _vm._e(), _vm.tabShow == false ? _c('div', {
    staticClass: "tab-title"
  }, [_vm._v("域名查询")]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mobileTabShow,
      expression: "mobileTabShow"
    }],
    staticClass: "tab-box"
  }, [_c('div', {
    staticClass: "tab-box-shadow",
    on: {
      "click": _vm.tab
    }
  }), _c('div', {
    staticClass: "tab-box-right"
  }, [_vm._l(_vm.mobileList.slice(0, 1), function (item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "tab-box-item",
      staticStyle: {
        "justify-content": "start"
      },
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '1' + index);
        }
      }
    }, [_vm.navIndex == '1' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '1' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.35rem"
      },
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '1' + index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), _vm._l(_vm.mobileList.slice(3, 4), function (item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "tab-box-item",
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '4' + index);
        }
      }
    }, [_vm.navIndex == '4' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '4' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.35rem"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), _vm._l(_vm.mobileList.slice(1, 2), function (item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "tab-box-item"
    }, [_vm.navIndex == '2' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '2' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.35rem"
      },
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '2' + index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "getnavShow",
      on: {
        "click": _vm.getcustomization
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.navShows == true,
        expression: "navShows == true"
      }],
      staticClass: "jiantou",
      attrs: {
        "src": require("../../../assets/mobileimg/jiantou1.png"),
        "alt": ""
      }
    }), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.navShows == false,
        expression: "navShows == false"
      }],
      staticClass: "jiantou",
      attrs: {
        "src": require("../../../assets/mobileimg/jiantou2.png"),
        "alt": ""
      }
    })])]);
  }), _vm._l(_vm.mobileList.slice(2, 3), function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.navShows,
        expression: "navShows"
      }],
      key: item.name,
      staticClass: "tab-box-item",
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '3' + index);
        }
      }
    }, [_vm.navIndex == '3' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '3' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.5rem",
        "color": "#666666"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), _vm._l(_vm.mobileList.slice(4, 5), function (item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "tab-box-item"
    }, [_vm.navIndex == '5' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '5' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.35rem"
      },
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '5' + index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "getnavShow",
      on: {
        "click": _vm.getnavShow
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.navShow == true,
        expression: "navShow == true"
      }],
      staticClass: "jiantou",
      attrs: {
        "src": require("../../../assets/mobileimg/jiantou1.png"),
        "alt": ""
      }
    }), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.navShow == false,
        expression: "navShow == false"
      }],
      staticClass: "jiantou",
      staticStyle: {
        "margin-left": "0.26rem"
      },
      attrs: {
        "src": require("../../../assets/mobileimg/jiantou2.png"),
        "alt": ""
      }
    })])]);
  }), _vm._l(_vm.mobileList.slice(5, 8), function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.navShow,
        expression: "navShow"
      }],
      key: item.name,
      staticClass: "tab-box-item",
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '6' + index);
        }
      }
    }, [_vm.navIndex == '6' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '6' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.5rem",
        "color": "#666666"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), _vm._l(_vm.mobileList.slice(8), function (item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "tab-box-item",
      on: {
        "click": function ($event) {
          return _vm.tabitem(item.url, index, '7' + index);
        }
      }
    }, [_vm.navIndex == '7' + index ? _c('div', {
      staticClass: "dian"
    }) : _vm._e(), _c('p', {
      class: _vm.navIndex == '7' + index ? 'pBold' : '',
      staticStyle: {
        "margin-left": "0.35rem"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  })], 2)]), _c('div', {
    staticClass: "box-item"
  }, [_vm.showLogin == true ? _c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 2.png"),
      "alt": ""
    },
    on: {
      "click": _vm.getlodinshow
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 2.png"),
      "alt": ""
    },
    on: {
      "click": _vm.personalcenter
    }
  }), _c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 448.png"),
      "alt": ""
    },
    on: {
      "click": _vm.tab
    }
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loginShow,
      expression: "loginShow"
    }],
    staticClass: "login-box-box"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "get-register",
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注册")]), _c('div', {
    staticClass: "get-login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])]), _c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.getlodinshow
    }
  })])])]), _c('div', {
    staticClass: "style-phone"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/style-phone.png"),
      "alt": ""
    },
    on: {
      "click": _vm.getphone
    }
  })]), _c('div', {
    staticClass: "pop-phone"
  }, [_c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: _vm.phoneshow,
      callback: function ($$v) {
        _vm.phoneshow = $$v;
      },
      expression: "phoneshow"
    }
  }, [_c('div', {
    staticClass: "phone-box"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.phone1
    }
  }, [_c('div', {
    staticClass: "phone-item",
    staticStyle: {
      "border-radius": "0.1rem 0.1rem 0 0"
    }
  }, [_vm._v(" 0356-210068 ")])]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.phone2
    }
  }, [_c('div', {
    staticClass: "phone-item",
    staticStyle: {
      "border-radius": "0 0 0.1rem 0.1rem"
    }
  }, [_vm._v(" 400-100-6992 ")])]), _c('div', {
    staticClass: "phone-btn",
    on: {
      "click": _vm.nophone
    }
  }, [_vm._v("取消")])])])], 1), _c('div', {
    staticClass: "box-center"
  }, [_c('router-view')], 1), _c('div', {
    staticClass: "pc-main"
  }, [_c('div', {
    staticClass: "box-center9 wow fadeInUp",
    attrs: {
      "data-wow-offset": "50"
    }
  }, [_c('div', {
    staticClass: "box-center9-top"
  }, [_c('div', {
    staticClass: "lift"
  }, [_c('div'), _c('div', [_vm._v("联系我们")]), _c('div', [_vm._v(" 联系电话 : "), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.relation.phone))])]), _c('div', {
    staticClass: "lift1"
  }, [_vm._v(" 技术支持 : "), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("茹工 " + _vm._s(_vm.relation.title) + "（7*24小时）")])]), _c('div', {
    staticClass: "lift1"
  }, [_vm._v(" 服务热线 : "), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.relation.hotLine))])]), _c('div', {
    staticClass: "lift1"
  }, [_c('a', {
    attrs: {
      "href": "mailto:test@jsphp.net?subject=test&cc=sample@hotmail.com&subject=主题&body=内容"
    }
  }, [_vm._v(" 邮箱 : "), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.relation.email))])])]), _c('div', {
    staticClass: "lift1"
  }, [_c('a', {
    attrs: {
      "href": 'https://www.amap.com/search?query=%E6%AD%A3%E6%B5%B7%E5%A4%A7%E5%8E%A6&city=140500&geoobj=112.201853%7C35.152676%7C113.871793%7C35.869153&zoom=10.24',
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "19px",
      "margin-top": "3px",
      "margin-left": "-1px"
    },
    attrs: {
      "src": require("../../../assets/pcimg/address.png"),
      "alt": ""
    }
  }), _vm._v(" 运营中心地址 : "), _c('span', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.relation.address))])])]), _c('div', {
    staticClass: "lift1"
  }, [_c('a', {
    attrs: {
      "href": "https://www.amap.com/search?id=B01640MK9F&city=140525&geoobj=112.893889%7C35.491%7C112.904813%7C35.495738&query_type=IDQ&query=%E6%99%8B%E5%9F%8E%E5%B8%82%E5%AE%A2%E8%BF%90%E4%B8%9C%E7%AB%99&zoom=17.5",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "19px",
      "margin-top": "3px"
    },
    attrs: {
      "src": require("../../../assets/pcimg/comaddress.png"),
      "alt": ""
    }
  }), _vm._v(" 公司注册地址 : "), _c('span', {
    staticStyle: {
      "color": "#ffffff",
      "line-height": "30px"
    }
  }, [_vm._v(_vm._s(_vm.relation.registeredAddress))])])])]), _c('div', {
    staticClass: "right"
  }, [_vm._m(0), _c('p', [_vm._v("关注我们")]), _c('div', {
    staticClass: "wx-add"
  }, _vm._l(_vm.queryImgList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "wx-item"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "wx-add-title"
    }, [_vm._v(_vm._s(item.title))])]);
  }), 0), _c('div', {
    staticClass: "views"
  }, [_vm._v(" 官网实时浏览量："), _c('span', {
    staticClass: "viscod"
  }, [_vm._v(_vm._s(_vm.viser[0] ? _vm.viser[0].websiteViews : 0))]), _c('span', {
    staticClass: "vispan"
  }, [_vm._v("官网注册量：")]), _c('span', {
    staticClass: "viscod"
  }, [_vm._v(_vm._s(_vm.viser[0] ? _vm.viser[0].websiteRegistis : 0))])])])]), _vm._m(1)]), _c('div', {
    staticClass: "phone-wechart"
  }, [_c('el-popover', {
    attrs: {
      "placement": "left",
      "width": "250",
      "popper-class": "tag-popover",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "phoneic",
    on: {
      "click": _vm.seekadvice
    }
  }, [_c('div', {
    staticClass: "phoneicosnt"
  }, [_c('div', {
    staticClass: "phoneicosnt-tit"
  }, [_vm._v("在线咨询")]), _c('div', [_vm._v("专属的客服为您在线解答")])])]), _c('div', {
    staticClass: "phone-icon",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": _vm.seekadvice
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "customer-icon-img"
  }), _c('div', [_vm._v("客服")])])]), _c('el-popover', {
    attrs: {
      "placement": "left",
      "width": "250",
      "popper-class": "tag-popover",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "phoneic"
  }, [_c('div', {
    staticClass: "phoneicos"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/phone5442x.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "phoneicosnt"
  }, [_c('div', {
    staticClass: "phoneicosnt-tit"
  }, [_vm._v("联系电话")]), _c('div', [_vm._v("0356-2100068 / 15364667403")])])]), _c('div', {
    staticClass: "phoneic"
  }, [_c('div', {
    staticClass: "phoneicos"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/hotline5462x.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "phoneicosnt"
  }, [_c('div', {
    staticClass: "phoneicosnt-tit"
  }, [_vm._v("服务热线")]), _c('div', [_vm._v("400-100-6992")])])]), _c('div', {
    staticClass: "phone-icon",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "phone-icon-img"
  }), _c('div', [_vm._v("电话")])])]), _c('el-popover', {
    attrs: {
      "placement": "left",
      "width": "250",
      "popper-class": "tag-popover",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "wechatic"
  }, [_c('div', {
    staticClass: "wechaticos"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/wecharteioc.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "wechaticosnt"
  }, [_c('div', {
    staticClass: "wechaticosnt-tit"
  }, [_vm._v("请关注我们！")]), _c('div', [_vm._v("晋城鼎峰网络科技")])])]), _c('div', {
    staticClass: "WeChat-icon",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "WeChat-icon-img"
  }), _c('div', [_vm._v("微信")])])])], 1), _vm.seekadviceflage == true ? _c('div', {
    staticClass: "consultation"
  }, [_c('div', {
    staticClass: "consultationtop"
  }, [_vm._m(2), _c('div', {
    staticClass: "consultaticon"
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.close
    }
  })])]), _vm.consultationtesShow == '1' ? _c('div', {
    staticClass: "consultationtes"
  }, [_c('div', {
    staticClass: "consultatfz"
  }, [_vm._v(" 您好，您可以留下联系方式，工作人员会第一时间给予您回复！ ")]), _c('div', {
    staticClass: "consultatfzitem"
  }, [_vm._m(3), _c('div', {
    staticClass: "consultatfzitemdiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.username,
      expression: "username"
    }],
    attrs: {
      "placeholder": "请输入您的姓名",
      "type": "text"
    },
    domProps: {
      "value": _vm.username
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.username = $event.target.value;
      }, _vm.getinput]
    }
  })])]), _c('div', {
    staticClass: "remind"
  }, [_vm._v(_vm._s(_vm.usernameremind))]), _c('div', {
    staticClass: "consultatfzitem"
  }, [_vm._m(4), _c('div', {
    staticClass: "consultatfzitemdiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    attrs: {
      "placeholder": "请输入您的电话",
      "type": "text"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.phone = $event.target.value;
      }, _vm.getinput]
    }
  })])]), _c('div', {
    staticClass: "remind"
  }, [_vm._v(_vm._s(_vm.phoneemind))]), _c('div', {
    staticClass: "consultatfzitem"
  }, [_vm._m(5), _c('div', {
    staticClass: "consultatfzitemdiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    attrs: {
      "placeholder": "请输入您的邮箱",
      "type": "text"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }, _vm.getinput]
    }
  })])]), _c('div', {
    staticClass: "remind"
  }, [_vm._v(_vm._s(_vm.emailemind))]), _c('div', {
    staticClass: "consultatfzitem"
  }, [_vm._m(6), _c('div', {
    staticClass: "consultatfzitemdiv",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-input', {
    attrs: {
      "resize": "none",
      "type": "textarea",
      "rows": 2,
      "maxlength": "255",
      "placeholder": "留言内容(255字)"
    },
    on: {
      "input": _vm.getinput
    },
    model: {
      value: _vm.note,
      callback: function ($$v) {
        _vm.note = $$v;
      },
      expression: "note"
    }
  })], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.consultatshow,
      expression: "consultatshow"
    }],
    staticClass: "consultatbtn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 提交 ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.consultatshowtwo,
      expression: "consultatshowtwo"
    }],
    staticClass: "consultatbtntwo"
  }, [_vm._v("提交")])]) : _vm._e(), _vm.consultationtesShow == '2' ? _c('div', {
    staticClass: "Submitted-successfully"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/Submitted-successfully.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "Submitted-successfully-text"
  }, [_vm._v("提交成功")])]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "mobile-main"
  }, [!_vm.isMobileItemPicRoute ? _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-lift"
  }), _c('div', {
    staticClass: "title-right"
  }, [_vm._m(7), _vm._l(_vm.mobileCowContactList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('a', {
      attrs: {
        "href": item.address,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "link-item",
      attrs: {
        "src": _vm.linkBox[index].img,
        "alt": ""
      }
    })])]);
  })], 2)]), _c('div', {
    staticClass: "centent"
  }, [_c('div', {
    staticClass: "centent-lift"
  }, [_c('div', {
    staticClass: "itemmy-item"
  }, [_c('div', {
    staticClass: "itemmy"
  }, [_vm._v("联系我们")]), _c('div', {
    staticClass: "itemmy-box"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "wire"
  }), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.mobileRelation.phone
    }
  }, [_vm._v("联系电话 : " + _vm._s(_vm.mobileRelation.phone))])]), _c('div', {
    staticClass: "item itemss"
  }, [_c('div', {
    staticClass: "wire"
  }), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.mobileRelation.hotLine
    }
  }, [_vm._v("服务热线 : " + _vm._s(_vm.mobileRelation.hotLine))])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "wire"
  }), _vm._v(" 邮箱 : " + _vm._s(_vm.mobileRelation.email) + " ")]), _c('div', {
    staticClass: "item itemss"
  }, [_c('div', {
    staticClass: "wire"
  }), _vm._v(" 关注我们 ："), _c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/weicha.png"),
      "alt": ""
    },
    on: {
      "click": _vm.showPopup
    }
  })]), _c('div', {
    staticClass: "item items"
  }, [_c('div', {
    staticClass: "wire"
  }), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.ruphone
    }
  }, [_vm._v("技术支持 : 茹工 15364667403（7*24小时）")])]), _c('div', {
    staticClass: "item items"
  }, [_c('div', {
    staticClass: "wire"
  }), _vm._v(" 运营中心地址 : " + _vm._s(_vm.mobileRelation.address) + " ")])])]), _c('van-cell'), _c('van-popup', {
    model: {
      value: _vm.showPopupShow,
      callback: function ($$v) {
        _vm.showPopupShow = $$v;
      },
      expression: "showPopupShow"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mobileQueryImgList.imgUrl,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "van-popup-text"
  }, [_vm._v("长按/截图保存，微信识别二维码")])])], 1), _c('div', {
    staticClass: "centent-right"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "wire"
  }), _vm._v(" 公司注册地址 : " + _vm._s(_vm.mobileRelation.registeredAddress) + " ")]), _c('div', {
    staticClass: "quantity"
  }, [_c('div', {
    staticClass: "quantity-item"
  }, [_vm._m(8), _c('div', {
    staticClass: "quantity-content"
  }, [_vm._v(" " + _vm._s(_vm.viser[0] ? _vm.viser[0].websiteViews : 0) + " ")])]), _c('div', {
    staticClass: "quantity-item"
  }, [_vm._m(9), _c('div', {
    staticClass: "quantity-content"
  }, [_vm._v(" " + _vm._s(_vm.viser[0] ? _vm.viser[0].websiteRegistis : 0) + " ")])])])])]), _c('div', {
    staticClass: "centent-xian"
  }), _vm._m(10), _c('div', {
    staticClass: "centent-bottom2"
  }, [_vm._v(" COPYRIGHT© 2023 晋城鼎峰网络科技有限公司 ALL RIGHTS RESERVED.版权所有 ")])]) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "right-title"
  }, [_c('div', {
    staticClass: "friendlylink"
  }, [_vm._v("友情链接")]), _c('a', {
    staticClass: "right-title-itema",
    attrs: {
      "href": "https://www.huanuo.cn",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/Slice 4312wx.png"),
      "alt": ""
    }
  })]), _c('a', {
    staticClass: "right-title-itema",
    attrs: {
      "href": "https://hvo.net.cn",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/Slice 432r2x.png"),
      "alt": ""
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center9-bottom"
  }, [_c('div', {
    staticClass: "box-center9-bottom1"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("晋ICP备16000853号-16")])]), _c('img', {
    attrs: {
      "src": require("../../../assets/pcimg/national_emblem.png"),
      "alt": ""
    }
  }), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14050002000295",
      "target": "_blank"
    }
  }, [_vm._v(" 晋公安网备案14050002000295号")])]), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.jcdfkj.com/yyzz.jpg",
      "target": "_blank"
    }
  }, [_vm._v("工商营业执照")])])]), _c('div', {
    staticClass: "box-center9-bottom2"
  }, [_c('p', [_vm._v(" COPYRIGHT© 2023 晋城市鼎峰网络科技有限公司 ALL RIGHTS RESERVED.版权所有 ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "consultattopnt"
  }, [_c('div', {
    staticClass: "consultationimg"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "consultationr"
  }, [_c('div', {
    staticClass: "consultationrseek"
  }, [_vm._v("在线咨询")]), _c('div', {
    staticClass: "consultationrseekmis"
  }, [_vm._v(" 为您在线解答售前(5x8)、售后咨询(7x24)服务 ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "itemsize"
  }, [_c('span', {
    staticStyle: {
      "color": "#f50606"
    }
  }, [_vm._v("*")]), _vm._v("姓名 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "itemsize"
  }, [_c('span', {
    staticStyle: {
      "color": "#f50606"
    }
  }, [_vm._v("*")]), _vm._v("电话 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "itemsize"
  }, [_c('span', {
    staticStyle: {
      "color": "#f50606"
    }
  }, [_vm._v("*")]), _vm._v("邮箱 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "itemsize"
  }, [_c('span', {
    staticStyle: {
      "color": "#f50606"
    }
  }, [_vm._v("*")]), _vm._v("留言 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "item"
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "font-weight": "bold",
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "link-Box",
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 220 (1).png"),
      "alt": ""
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "quantity-title"
  }, [_c('div', {
    staticClass: "wire"
  }), _vm._v(" 官网实时浏览量： ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "quantity-title"
  }, [_c('div', {
    staticClass: "wire"
  }), _vm._v(" 官网实时注册量： ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "centent-bottom1"
  }, [_c('div', {
    staticClass: "div1"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/index",
      "target": "_blank"
    }
  }, [_vm._v("晋ICP备16000853号-16")])]), _c('div', {
    staticClass: "div2"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 247.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "div3"
  }, [_c('a', {
    attrs: {
      "href": "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14050002000295",
      "target": "_blank"
    }
  }, [_vm._v("晋公安网备案14050002000295号")])]), _c('div', {
    staticClass: "div4"
  }, [_c('a', {
    attrs: {
      "href": "https://www.jcdfkj.com/yyzz.jpg",
      "target": "_blank"
    }
  }, [_vm._v("工商营业执照")])])]);
}];
export { render, staticRenderFns };